import React from "react";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ArrowRight } from "@mui/icons-material";
import { arrowTypographyStyles } from "../style";
import DataTools from "../../../DataTools/DataTools";

const Description = () => {
  const displayedTool = DataTools.find((tool) => tool.id === parseInt(1));
  if (!displayedTool) {
    return <div>Tool not found</div>;
  }
  return (
    <Box>
      <Stack spacing={2} useFlexGap sx={{ width: { xs: "100%", sm: "100%" } }}>
        <Typography
          variant="h1"
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignSelf: "center",
            textAlign: "center",
            fontSize: "clamp(1rem, 10vw, 2rem)",
          }}
          // sx={arrowTypographyStyles}
        >
          IP Isolation Packer
        </Typography>
        <Typography
          variant="h3"
          sx={{
            ...arrowTypographyStyles,
            paddingLeft: { xs: "0", md: "15px" }, // Add paddingLeft for different screen sizes
          }}
        >
          Tool Description
        </Typography>

        <Typography
          variant="h5"
          sx={{
            // fontFamily:"calibri",
            paddingLeft: { xs: "0", md: "40px" }, // Adjust the margin-left for different screen sizes
          }}
        >
          Mechanics and Features
        </Typography>
        <Typography
          textAlign="justify"
          color="text.secondary"
          sx={{
            alignSelf: "start",
            width: {
              sm: "100%",
              md: "100%",
            },
            // textIndent: "29px", // Apply text indentation
            paddingLeft: "50px", // Apply left padding
            paddingRight: "30px", // Apply right padding
          }}
          paragraph
        >
          The Model ‘IP’ Isolation Packer is set by hydraulic pressure and
          released by picking up.
          <br />
          The Model ‘IP’ Isolation Packer is high-performance Packer with simple
          mechanics and a big bore.
        </Typography>

        <Typography
          variant="h5"
          sx={{
            // fontFamily:"calibri",
            paddingLeft: { xs: "0", md: "40px" }, // Adjust the margin-left for different screen sizes
          }}
        >
          Application
        </Typography>
        <Typography
          textAlign="justify"
          color="text.secondary"
          sx={{
            alignSelf: "start",
            width: {
              sm: "100%",
              md: "100%",
              textIndent: "29px",
              padding: "0px 30px 0px 30px",
            },
          }}
          paragraph
        >
          The Model ‘IP’ Isolation Packer is mainly used to isolate zones ,
          which is compatible with RF-Model‘HR’ Packer or other tools to be used
          for layered water location, layered water shutoff, layered
          acidification, layered sand control and layered production operations.
          <br />
        </Typography>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ paddingLeft: "50px" }}>
          <ArrowRight />
          <Typography>Pressure Grade：10000psi</Typography>
        </Stack>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ paddingLeft: "50px" }}>
          <ArrowRight />
          <Typography>Temperature Rating：0—180°C</Typography>
        </Stack>
      </Stack>
      <Box
        sx={{
          width: "100%", // Set the width of the outer box
          //maxWidth: '140px', // Set the maximum width of the outer box
          display: "flex",
          justifyContent: "center", // Center the content horizontally
          flexWrap: "wrap", // Allow the content to wrap if needed
          //backgroundColor: 'green',

          mt: 2, // Add margin at the top
        }}
      >
        <img
          src={displayedTool.image}
          alt={`Swellable Packer Tool`}
          style={{
            width: "100%", // Set the width of the image
            maxWidth: "466px",
            height: "auto", // Automatically adjust the height based on the width
            // display: 'inline-block', // Ensure the image is displayed as an inline block
          }}
        />
      </Box>
      <Typography
        variant="h5"
        textAlign="start" // Align text to the start (left)
        sx={{ mt: "30px", paddingLeft: { xs: "0", md: "40px" } }}
      >
        Technical Parameters
      </Typography>
    </Box>
  );
};

export default Description;
